import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton } from "@/pages/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { formatApiError } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.onboarding_completed || ["admin", "editor"].includes(u.role) ? "/dashboard" : "/onboarding");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Selamat datang kembali" subtitle="Masuk untuk melanjutkan analisis Anda."
      footer={<>Belum punya akun? <Link to="/register" className="text-teal font-semibold" data-testid="to-register">Daftar gratis</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        {error && <div data-testid="login-error" className="bg-red-50 text-red-700 text-sm rounded-xl p-3">{error}</div>}
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl h-12 mt-1" placeholder="nama@email.com" />
        </div>
        <div>
          <div className="flex justify-between items-center">
            <Label htmlFor="password">Kata Sandi</Label>
            <Link to="/forgot-password" className="text-xs text-teal" data-testid="to-forgot">Lupa kata sandi?</Link>
          </div>
          <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl h-12 mt-1" placeholder="••••••••" />
        </div>
        <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full h-12 rounded-full bg-teal hover:bg-teal-hover text-base font-semibold">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Masuk"}
        </Button>
      </form>
      <div className="flex items-center gap-3 my-5"><div className="h-px bg-border flex-1" /><span className="text-xs text-muted-foreground">atau</span><div className="h-px bg-border flex-1" /></div>
      <GoogleButton label="Masuk dengan Google" />
    </AuthShell>
  );
}
